export default __webpack_public_path__ + "static/img-uptodate-planning-109e1af1e96725c5e1ca34dc4bad18dc.png";